<template>
  <div v-if="notificationMessage" class="notification">
    {{ notificationMessage }}
  </div>
</template>

<script>
import { useNotification } from "@/services/notificationService";

export default {
  name: "GlobalNotification",
  setup() {
    const { notificationMessage } = useNotification();
    return { notificationMessage };
  },
};
</script>

<style scoped>
.notification {
  position: fixed;
  top: 60px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  padding: 10px 20px;
  color: #fff;
  border-radius: 5px;
  z-index: 3000;
  animation: fadeInOut 3s forwards;
  max-width: 300px; /* prevent super-wide notifications */
}

/* Simple fade in/out keyframes */
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* MOBILE ADJUSTMENTS */
@media (max-width: 600px) {
  .notification {
    top: 50px;      /* to match the smaller nav height, if changed */
    right: 10px;    /* narrower margins */
    width: calc(100% - 20px);
    max-width: none; /* Let it fill up to the edge if needed */
    box-sizing: border-box;
  }
}
</style>
